import { action, makeObservable, observable } from 'mobx';
import { cameraConfigs } from "../rouletteCanvas/camera";

class VideoInfoStore {
  isVideoOpen = false;
  isSmallWidth = false;
  isVideoAuto = true;
  isVideoVertical = false;

  constructor() {
    makeObservable(this, {
      isVideoOpen: observable,
      isSmallWidth: observable,
      isVideoVertical: observable,
      isVideoAuto: observable,
      setIsVideoOpen: action.bound,
      setIsSmallWidth: action.bound,
      setIsVideoAuto: action.bound,
      setIsVideoVertical: action.bound,
    });
  }

  setIsVideoOpen(bool) {
    this.isVideoOpen = bool;
  }

  setIsVideoVertical(bool) {
    this.isVideoVertical = bool;
    cameraConfigs.movement.set(this.isVideoAuto, this.isVideoVertical);
  }

  setIsSmallWidth(type) {
    this.isSmallWidth = type;
  }

  setIsVideoAuto(bool) {
    this.isVideoAuto = bool;
    cameraConfigs.movement.set(this.isVideoAuto, this.isVideoVertical);
  }
}

export const videoInfoStore = new VideoInfoStore();
